import { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import { ArrowPathRoundedSquareIcon, CalendarDaysIcon } from '@heroicons/react/20/solid';
import { useNavigate } from 'react-router-dom'; // Import useNavigate


import Shifts from '../manager/shifts';
import StaffActions from './staffdashactions';
import { BellIcon, FolderOpenIcon, HeartIcon, MicrophoneIcon, SunIcon, UserIcon } from '@heroicons/react/24/solid';
import StaffIndvDetails from './staffindvdetails';
import SpeakUp from './speakup';
import Wellbeing from '../manager/Wellbeing';

const tabs = [
  { name: 'Shifts', component: <Shifts />, icon: CalendarDaysIcon },
  { name: 'Clock-In', component: <StaffActions />, icon: UserIcon },
  { name: 'Holiday Requests', url: '/staffholiday', icon: SunIcon },
  { name: 'My Details', component: <StaffIndvDetails/>, icon: FolderOpenIcon },
  { name: 'Speak Up', component: <SpeakUp />, icon: MicrophoneIcon },
  { name: 'Wellbeing', component: <Wellbeing />, icon: HeartIcon },
 

];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Example() {
  const [currentTabIndex, setCurrentTabIndex] = useState(0); // Default to the first tab index
  const navigate = useNavigate(); // Initialize useNavigate

  const handleTabChange = (index) => {
    setCurrentTabIndex(index);
  };

  return (
    <div className="w-full">
      <div className="sm:hidden w-full">
        {/* Mobile version - stylish button tabs with horizontal scroll, full width */}
        <div className="bg-gradient-to-r from-emerald-600 via-emerald-500 to-teal-500 p-3 rounded-xl shadow-lg mb-4 w-full">
          <h2 className="text-white font-bold text-sm mb-2 px-1">Management</h2>
          <div className="overflow-x-auto flex space-x-2 pb-1 hide-scrollbar w-full">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                onClick={() => {
                  if (tab.url) {
                    navigate(tab.url);
                  } else {
                    handleTabChange(index);
                  }
                }}
                className={classNames(
                  currentTabIndex === index
                    ? 'bg-white text-emerald-700 shadow-md transform scale-105 border-b-2 border-emerald-700'
                    : 'bg-emerald-600/40 text-white hover:bg-emerald-700/70 border-b-2 border-transparent',
                  'whitespace-nowrap px-2 py-2 text-xs font-medium rounded-md flex-shrink-0 transition-all duration-200 flex items-center min-w-[90px] justify-center'
                )}
              >
                {tab.icon && (
                  <tab.icon className={classNames(
                    currentTabIndex === index ? 'text-emerald-600' : 'text-white',
                    'mr-1 h-3.5 w-3.5'
                  )} />
                )}
                {tab.name}
              </button>
            ))}
          </div>
        </div>
        <style dangerouslySetInnerHTML={{__html: `
          .hide-scrollbar::-webkit-scrollbar {
            height: 4px;
          }
          .hide-scrollbar::-webkit-scrollbar-track {
            background: transparent;
          }
          .hide-scrollbar::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.5);
            border-radius: 20px;
          }
        `}} />
      </div>

      <div className="hidden sm:block w-full">
        {/* Desktop/tablet version - horizontal tab navigation with scrollable tabs */}
        <div className="bg-gradient-to-r from-emerald-500 to-teal-600 rounded-lg shadow-lg p-1 w-full">
          <nav aria-label="Tabs" className="flex overflow-x-auto flex-nowrap space-x-1 w-full hide-scrollbar">
            {tabs.map((tab, index) => (
              <button
                key={tab.name}
                onClick={() => {
                  if (tab.url) {
                    navigate(tab.url);
                  } else {
                    handleTabChange(index);
                  }
                }}
                className={classNames(
                  currentTabIndex === index
                    ? 'bg-white text-emerald-700 shadow-md'
                    : 'text-white hover:bg-white/20',
                  'rounded-md px-4 py-3 text-sm font-medium flex items-center transition-all duration-200 whitespace-nowrap min-w-[120px] justify-center'
                )}
              >
                {tab.icon && (
                  <tab.icon 
                    className={classNames(
                      currentTabIndex === index ? 'text-emerald-600' : 'text-white',
                      'mr-2 h-5 w-5'
                    )} 
                    aria-hidden="true" 
                  />
                )}
                {tab.name}
              </button>
            ))}
          </nav>
        </div>
        <style dangerouslySetInnerHTML={{__html: `
          .hide-scrollbar::-webkit-scrollbar {
            height: 4px;
          }
          .hide-scrollbar::-webkit-scrollbar-track {
            background: transparent;
          }
          .hide-scrollbar::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.5);
            border-radius: 20px;
          }
        `}} />
      </div>

      {/* Render the content of the selected tab */}
      <div className="mt-4 w-full">
        {tabs[currentTabIndex].component && tabs[currentTabIndex].component}
        {!tabs[currentTabIndex].component && tabs[currentTabIndex].url && (
          <div className="flex justify-center items-center p-8 text-gray-500">
            <p>Navigating to {tabs[currentTabIndex].url}...</p>
          </div>
        )}
      </div>
    </div>
  );
}
